export const GET_CART_PRODUCTS = "get/cart/products";
export const ADD_TO_CART = "add/cart/product";
export const DELETE_FROM_CART = "delete/cart/product";
export const RESET_CART = "reset/cart";
